"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _query = require("@reduxjs/toolkit/query");

var _services = require("@alycecom/services");

var _material = require("@mui/material");

var _ProductItem = require("../../../../../Marketplace/Products/components/ProductItem");

var _providers = require("../../../../providers");

var styles = {
  text: {
    color: 'text.primary',
    fontSize: '14px',
    lineHeight: '18px'
  },
  bold: {
    fontWeight: 700
  }
};

var GiftPreview = function GiftPreview() {
  var _batch$defaultProduct, _batch$defaultProduct2, _batch$defaultProduct3;

  var _useGiftingFlowContex = (0, _providers.useGiftingFlowContext)(),
      batchId = _useGiftingFlowContex.batchId;

  var _useGetProspectingBat = (0, _services.useGetProspectingBatchByIdQuery)(batchId ? {
    batchId
  } : _query.skipToken),
      batch = _useGetProspectingBat.data;

  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    maxWidth: 165
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: [styles.text, styles.bold]
  }, "Gift"), (batch === null || batch === void 0 ? void 0 : (_batch$defaultProduct = batch.defaultProduct) === null || _batch$defaultProduct === void 0 ? void 0 : _batch$defaultProduct.id) && /*#__PURE__*/_react.default.createElement(_ProductItem.ConnectedDefaultProductItem, {
    mt: 1,
    id: batch === null || batch === void 0 ? void 0 : (_batch$defaultProduct2 = batch.defaultProduct) === null || _batch$defaultProduct2 === void 0 ? void 0 : _batch$defaultProduct2.id,
    denomination: batch === null || batch === void 0 ? void 0 : (_batch$defaultProduct3 = batch.defaultProduct) === null || _batch$defaultProduct3 === void 0 ? void 0 : _batch$defaultProduct3.denomination
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 9
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: [styles.text, styles.bold]
  }, "Total Contacts"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, batch === null || batch === void 0 ? void 0 : batch.contactsTotal)));
};

var _default = GiftPreview;
exports.default = _default;